import { gql } from '@apollo/client';

const REVIEW_HOLTER_EVENTS_MUTATION = gql`
  mutation ReviewHolterEvents($input: ReviewHolterEventsInputV2!) {
    reviewHolterEventsV2(input: $input) {
      isSuccess
      message
      messageId
      command
    }
  }
`;

export default REVIEW_HOLTER_EVENTS_MUTATION;
